<!--
 * @Description: 这是翻译引导页面（组件）
 * @Date: 2021-06-16 14:06:44
 * @Author: 米虫
 * @LastEditors: 米虫
 * @LastEditTime: 2021-06-16 16:15:46
-->
<template>
    <div class="translate-container">
        <div class="back" @click="$router.back()">
            <img src="../../assets/images/icon_back_translate.png" />Step
        </div>
        <div class="first-step">
            <div class="step-header-content">
                <div>1、</div>
                <div class="step-title">Click copy link：</div>
            </div>
            <div class="step-content">
                Copy link to Google tour or other tour Open t- o view the English version of the page
            </div>
            <div
                class="copy-btn"
                v-clipboard:copy="redirect"
                v-clipboard:success="onCopyAll"
                v-clipboard:error="onErrorAll"
            >
                <div class="copy">Copy Link</div>
            </div>
        </div>
        <div class="second-step">
            <div class="step-header-content">
                <div>2、</div>
                <div class="step-title">
                    Find the translator with translation function, and you can view the citation page
                </div>
            </div>
            <div class="step-content">
                The steps are as follows: click settings in the browser → Click translate again。
            </div>
            <div class="step">Step：</div>
            <div class="second-step-title">(1) Click settings</div>
            <img src="../../assets/images/icon_step.png" />
            <div class="second-step-title">(2) Click translate</div>
            <img src="../..//assets/images/icon_step2.png" />
        </div>
    </div>
</template>
<script>
export default {
    props: {
        redirect: {
            type: String,
            default: '',
        },
    },
    data() {
        return {}
    },
    methods: {
        onCopyAll(e) {
            this.$message('复制成功')
        },
        onErrorAll(e) {
            this.$message.error('复制失败')
        },
    },
}
</script>
<style lang="scss" scoped>
@import '../../assets/style/mixin';
.translate-container {
    //height：100%,width:100%)
    @include wh(100vw, 100vh);
    background-color: #fff;
    box-sizing: border-box;
    padding: vw(16) vw(10);
    overflow: auto;
    -webkit-overflow-scrolling: touch; //实现苹果手机的滚动回弹效果
}
.back {
    font-size: vw(17);
    margin-bottom: vw(18);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
}
.step-title {
    font-size: vw(17);
    font-weight: 400;
    color: #333333;
}
.step-header-content {
    display: flex;
    margin-bottom: vw(12);
}
.step-content {
    margin-left: vw(25.5);
    margin-bottom: vw(15.5);
}
.copy-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: vw(17);
    cursor: pointer;
}
.copy {
    width: vw(120);
    height: vw(36);
    background-color: #3766e1;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    border-radius: vw(4);
}
.step {
    @extend .back;
    margin-left: vw(26);
}
.second-step-title {
    margin-left: vw(26);
    margin-bottom: vw(12.5);
    margin-top: vw(12.5);
}
</style>
